import { GlButton, GlModal, GlModalDirective, GlTooltipDirective, GlSprintf, GlLink, GlFormInputGroup, GlDisclosureDropdownItem, GlToastMixin } from '@gitlab/ui';
import { sprintf, s__ } from '~/locale';
import SimpleCopyButton from '~/vue_shared/components/simple_copy_button.vue';
import namespaceRegenerateNewWorkItemEmailAddressMutation from '../graphql/namespace_regenerate_new_work_item_email_address.mutation.graphql';
export default {
    i18n: {
        sendEmail: s__('WorkItem|Send email'),
        emailNewWorkItem: {
            text: s__('WorkItem|Email work item to this project')
        },
        createNewWorkItemByEmail: s__('WorkItem|Create new work item by email'),
        failedToRegenerateEmail: s__('WorkItem|There was an error when resetting email token.'),
        workItemCreationInstruction: s__('WorkItem|You can create a new work item inside this project by sending an email to the following email address:'),
        emailSubjectDescription: s__('WorkItem|The subject is used as the title of the new work item, and the message is the description. %{quickActionsLinkStart}Quick actions%{quickActionsLinkEnd} and styling with %{markdownLinkStart}Markdown%{markdownLinkEnd} are supported.'),
        privateEmailWarning: s__('WorkItem|This is a %{emailsHelpLinkStart}private email address%{emailsHelpLinkEnd} generated just for you. Anyone who has it can create work items and merge requests as if they were you. If that happens, %{resetLinkStart}reset this token%{resetLinkEnd}.')
    },
    name: 'WorkItemByEmail',
    components: {
        GlButton,
        GlModal,
        GlSprintf,
        GlLink,
        GlFormInputGroup,
        SimpleCopyButton,
        GlDisclosureDropdownItem
    },
    directives: {
        GlModal: GlModalDirective,
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        GlToastMixin
    ],
    inject: {
        newWorkItemEmailAddress: {
            default: null
        },
        emailsHelpPagePath: {
            default: ''
        },
        quickActionsHelpPath: {
            default: ''
        },
        markdownHelpPath: {
            default: ''
        },
        fullPath: {
            default: ''
        }
    },
    data () {
        return {
            email: this.newWorkItemEmailAddress,
            isRegenerating: false
        };
    },
    computed: {
        mailToLink () {
            const subject = sprintf(s__('WorkItem|Enter the work item title'));
            const body = sprintf(s__('WorkItem|Enter the work item description'));
            return `mailto:${this.email}?subject=${subject}&body=${body}`;
        }
    },
    methods: {
        async regenerateIncomingEmailToken () {
            if (this.isRegenerating) return;
            this.isRegenerating = true;
            try {
                const { data } = await this.$apollo.mutate({
                    mutation: namespaceRegenerateNewWorkItemEmailAddressMutation,
                    variables: {
                        fullPath: this.fullPath
                    }
                });
                if (data.namespacesRegenerateNewWorkItemEmailAddress?.errors?.length > 0) {
                    throw new Error(data.namespacesRegenerateNewWorkItemEmailAddress.errors[0]);
                }
                const newEmail = data.namespacesRegenerateNewWorkItemEmailAddress?.namespace?.linkPaths?.newWorkItemEmailAddress;
                if (newEmail) {
                    this.email = newEmail;
                }
            } catch  {
                this.$toast.show(this.$options.i18n.failedToRegenerateEmail);
            } finally{
                this.isRegenerating = false;
            }
        },
        cancelHandler () {
            this.$refs.modal.hide();
        }
    },
    modalId: 'work-item-email-modal'
};
